import React from 'react';
import { Form } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';

import CommonModal from '../../../../components/common-modal/CommonModal';
import LabelSettingsFormInner from './LabelSettingsFormInner';
import { updateLabelSettings } from '../../../../redux/sonar/sonarReducer';

function LabelSettingsModal({ isOpen, onClose, onCancel }) {
  const dispatch = useDispatch();
  const labelSettings = useSelector((state) => state.sonarDashboard.labelSettings);

  const labelSettingsFormInitialValues = {
    groupNames: labelSettings.groupNames,
    countryCode: labelSettings.countryCode,
  };

  const handleSubmit = async (values) => {
    await dispatch(updateLabelSettings(values));
    onClose();
  };

  return (
    <CommonModal isOpen={isOpen} onClose={onClose}>
      <Form
        initialValues={labelSettingsFormInitialValues}
        onSubmit={handleSubmit}
        subscription={{ submitting: true, pristine: true, submitError: true }}
        render={({ handleSubmit }) => <LabelSettingsFormInner onSubmit={handleSubmit} onCancel={onCancel} />}
      />
    </CommonModal>
  );
}

export default LabelSettingsModal;
